"use client";

import styled from "styled-components";

export const ParagraphTitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.8rem;
  width: 100%;
  height: 3.4rem;
  padding: 0;

  font-family: ${({ theme }) => theme.font.fontFamily.jost};
  font-size: 2.4rem;
  font-style: normal;
  font-weight: 600;
  color: var(--Color-Common-Text-Success, #0198e9);
  line-height: 100%;

  .article-detail-mobile-ui-true & {
    height: 2.7rem;
    font-size: 1.8rem;
  }

  @media only screen and (max-width: 768px) {
    height: 2.7rem;
    font-size: 1.8rem;
  }
`;

export const ParagraphSectionTitleWrapper = styled.div`
  color: var(--Color-Common-Text-Success-Bold, #015d8e);
  font-family: var(--font-pt-serif);
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%; /* 24px */
`;
